/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import {
  CustomSelectContainer,
  CustomSelectStyle,
  InputLabelContainer,
  TextFieldArea,
} from './styles';
import { InputError } from '../typography';
import Select from 'react-select/async';
import { Tooltip, useTheme } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export type TCustomValue = {
  label?: string;
  value?: string;
};

export interface ICustomSelectAsyncProps {
  labelValue?: string;
  value?: TCustomValue | TCustomValue[];
  validationError?: string;
  handleInputChange: (v: any) => void;
  onBlur?: (v: any) => void;
  loadOptions: any;
  name: string;
  multi?: boolean;
  placeholder?: string;
  disabled?: boolean;
  isClearable?: boolean;
  withInput?: boolean;
  defaultOptions: any;
  isLoading?: boolean;
  styles?: React.CSSProperties;
  tooltip?: string;
}

const CustomSelectAsync = ({
  labelValue,
  tooltip,
  handleInputChange,
  value,
  validationError,
  loadOptions,
  onBlur,
  multi,
  placeholder,
  name,
  disabled,
  isLoading,
  defaultOptions,
  isClearable = true,
  withInput,
  styles,
}: ICustomSelectAsyncProps) => {
  const theme = useTheme();
  const customSelectStyle = useMemo(
    () => CustomSelectStyle(theme, styles, withInput),
    [theme, styles, withInput],
  );
  return (
    <CustomSelectContainer withInput={withInput}>
      {labelValue && (
        <InputLabelContainer>
          {labelValue}{' '}
          {tooltip && (
            <Tooltip title={tooltip}>
              <HelpOutlineIcon
                style={{
                  fontSize: 16,
                  color: theme.palette.brand.primary.base,
                  marginLeft: 5,
                }}
              />
            </Tooltip>
          )}
        </InputLabelContainer>
      )}
      <TextFieldArea>
        <Select
          inputId={name}
          value={Array.isArray(value) || value?.value ? value : undefined}
          onChange={(v: any) =>
            handleInputChange({
              currentTarget: { name, value: v },
              target: { name, value: v },
            })
          }
          placeholder={placeholder}
          isClearable={isClearable}
          styles={{ ...customSelectStyle, ...((styles as any) ?? {}) }}
          isMulti={multi}
          loadOptions={loadOptions}
          isDisabled={disabled}
          defaultOptions={defaultOptions}
          isLoading={isLoading}
          loadingMessage={() => 'Carregando tomadores...'}
          onBlur={() =>
            onBlur &&
            onBlur({
              currentTarget: { name },
              target: { name },
            })
          }
        />
      </TextFieldArea>
      {validationError && <InputError>{validationError}</InputError>}
    </CustomSelectContainer>
  );
};

export default CustomSelectAsync;
